import "../styles/components/LandingCard.css";

export default function Card({ children }) {
  return <div className="card">{children}</div>;
}
